import {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { SCENARIO_PLANNER_METRICS } from '../scenario-planner.constants';
import { ExtendedCellProps } from './scenario-planner-details-table.component';

const options = [
  {
    value: SCENARIO_PLANNER_METRICS.DEPTH_OF_DISCOUNT,
    label: 'Depth Of Discount',
  },
  {
    value: SCENARIO_PLANNER_METRICS.ANY_PROMO_UNIT_PRICE,
    label: 'Any Promo Unit Price',
  },
];
interface DepthOfDiscountDropdownComponentProps {
  idField: string | undefined;
  setIdField: Dispatch<SetStateAction<string | undefined>>;
}
const DepthOfDiscountDropdownComponent = ({
  idField,
  setIdField,
}: DepthOfDiscountDropdownComponentProps) => {
  return (
    <select
      className={'form-select change-mode'}
      onClick={(event) => event.stopPropagation()}
      value={idField}
      onChange={(e) => setIdField(e.target.value)}
      disabled={false}
    >
      {options?.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export const ScenarioPlannerInputHeaderComponent = ({
  onRunEditMode,
  onClearColumn,
  col,
  inputTypeOptions,
}: ExtendedCellProps) => {
  const [changeType, setChangeType] = useState<string | undefined>(
    col.inputTypeId,
  );
  const [idField, setIdField] = useState<string | undefined>(col.idField);
  const [isClearing, setIsClearing] = useState<boolean>(false);

  // Check if column has any values to show clear button
  const columnHasValues = col.hasValues || false;

  const handleChangeType = useCallback(
    (value: string) => {
      setChangeType(value);
      if (onRunEditMode) {
        onRunEditMode([
          {
            fieldId: col.idField,
            inputType: value,
          },
        ]);
      }
    },
    [col.idField, onRunEditMode],
  );

  useEffect(() => {
    if (onRunEditMode && idField && col.idField !== idField) {
      onRunEditMode([
        {
          fieldId: idField,
          inputType: col.inputTypeId ?? 'perc',
          disabled: false,
        },
        {
          fieldId: col.idField,
          inputType: col.inputTypeId ?? 'perc',
          disabled: true,
        },
      ]);
    }
  }, [col.idField, col.inputTypeId, idField, onRunEditMode]);

  // Handle clear column button click
  const handleClearColumn = useCallback(async () => {
    if (onClearColumn && columnHasValues && !isClearing) {
      setIsClearing(true);
      try {
        await onClearColumn(col);
      } catch (error) {
        // Handle error
      } finally {
        setIsClearing(false);
      }
    }
  }, [onClearColumn, col, columnHasValues, isClearing]);

  const isDodOrApup = useMemo(() => {
    return (
      col.idField === SCENARIO_PLANNER_METRICS.DEPTH_OF_DISCOUNT ||
      col.idField === SCENARIO_PLANNER_METRICS.ANY_PROMO_UNIT_PRICE
    );
  }, [col.idField]);

  return (
    <div className={`scenario-planner-input-header ${col.id}`}>
      <div className="header-top-row">
        {columnHasValues && (
          <button
            type="button"
            className="btn-clear-column"
            onClick={handleClearColumn}
            disabled={isClearing}
            title="Clear all values in this column"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 4V10H7"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M23 20V14H17"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10M23 14L18.36 18.36A9 9 0 0 1 3.51 15"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        )}
        {isDodOrApup && (
          <DepthOfDiscountDropdownComponent
            idField={idField}
            setIdField={setIdField}
          />
        )}
        {!isDodOrApup && <div className="changeInput">{col.name}</div>}
      </div>
      <select
        className={'form-select change-type'}
        onClick={(event) => event.stopPropagation()}
        value={changeType}
        onChange={(e) => handleChangeType(e.target.value)}
        disabled={false}
      >
        {inputTypeOptions?.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};
